<template>
  <div>
    <agile-table
      :data="workOrders"
      :data-type="'workOrdersShare'"
      :table-meta="tableMeta"
      :filter-meta="filterMeta"
      :action-meta="actionMeta"
      :column-meta="columnMeta"
      :showContextMenu="true"
      @tableControlAction="tableControlAction"
      @rowAction="rowAction"
      @fieldAction="fieldAction" />
      <slideout-panel />
  </div>
</template>

<script>

import { mapState, mapActions, mapGetters } from 'vuex'
import WorkOrderModal from '@/components/modals/WorkOrderModal'
import UserModal from '@/components/modals/UserModal'
import CustomerModal from '@/components/modals/CustomerModal'
import ProjectModal from '@/components/modals/ProjectModal'

import AgileTable from '@/components/table/AgileTable'

export default {
  components: {
    AgileTable
  },

  props: {
    displayCreateButton: {
      type: Boolean,
      default: true
    },
    projectCode: {
      type: String
    },
    workOrderOwnerUserId: {
      type: Number,
      default: 0
    }
  },

  data () {
    return {
      debounceDelay: process.env.DEBOUNCE_DELAY,

      tableMeta: {
        headingIcon: 'fa-boxes',
        controls:
        [
          // {
          //   label: 'Status',
          //   placeholder: 'Alla',
          //   action: 'filterByStatus',
          //   controlType: 'select',
          //   options: [{
          //     key: 'quoted',
          //     value: 'Offererad'
          //   }, {
          //     key: 'planned',
          //     value: 'Planerad'
          //   }, {
          //     key: 'started',
          //     value: 'Pågående'
          //   }, {
          //     key: 'registered',
          //     value: 'Registrerad'
          //   }, {
          //     key: 'invoiced',
          //     value: 'Fakturerad'
          //   }, {
          //     key: 'cancelled',
          //     value: 'Makulerad'
          //   }],
          //   value: null
          // },
          {
            label: 'Status',
            placeholder: 'Alla',
            action: 'filterByStatuses',
            controlType: 'multi-select',
            options: [],
            fieldId: 'statuses',
            value: null
          }
        ]
      },

      filterMeta: [{
        fieldId: 'startDate',
        type: 'date',
        label: 'Startdatum'
      },
      {
        fieldId: 'endDate',
        type: 'date',
        label: 'Slutdatum'
      },
      // {
      //   fieldId: 'status',
      //   type: 'select',
      //   label: 'Status',
      //   options: [{
      //     key: 'planned',
      //     value: 'Planerad'
      //   }, {
      //     key: 'started',
      //     value: 'Pågående'
      //   }, {
      //     key: 'registered',
      //     value: 'Registrerad'
      //   }, {
      //     key: 'invoiced',
      //     value: 'Fakturerad'
      //   }, {
      //     key: 'cancelled',
      //     value: 'Makulerad'
      //   }]
      // },
      {
        fieldId: 'statuses',
        type: 'multi-select',
        placeholder: 'Välj status',
        options: [],
        label: 'Status'
      },
      {
        fieldId: 'ownerOrHelperInitials',
        type: 'string',
        label: 'Insatser tillhörande'
      },
      {
        fieldId: 'projectCode',
        type: 'string',
        label: 'Projektnummer'
      },
      {
        fieldId: 'objectName',
        type: 'string',
        label: 'Objekt'
      },
      {
        fieldId: 'customerName',
        type: 'string',
        label: 'Kund'
      },
      {
        fieldId: null
      },
      {
        fieldId: 'workOrderOwnerInitials',
        type: 'string',
        label: 'Ägare (Initialer)'
      },
      {
        fieldId: 'workOrderHelperInitials',
        type: 'string',
        label: 'Stöd (Initialer)'
      },
      {
        fieldId: 'invoiceNote',
        type: 'string',
        label: 'Extern not'
      },
      {
        fieldId: 'internalNote',
        type: 'string',
        label: 'Intern not'
      }],

      columnMeta: {
        hasActions: true,
        items: [{
          fieldId: 'verificationDate',
          label: 'Datum',
          dataType: 'date'
          // actionType: 'fieldAction',
          // action: 'displayWorkOrder'
        },
        {
          fieldId: 'objectName',
          label: 'Objekt'
          // actionType: 'fieldAction',
          // action: 'displayWorkOrder'
        },
        {
          fieldId: 'invoiceNote',
          label: 'Extern not'
          // actionType: 'fieldAction',
          // action: 'displayWorkOrder'
        },
        {
          fieldId: 'customerName',
          label: 'Kund'
          // actionType: 'fieldAction',
          // action: 'displayCustomer'
        },
        {
          fieldId: 'projectCode',
          label: 'Projektnummer',
          actionType: 'fieldAction',
          action: 'displayProject'
        },
        {
          fieldId: 'status',
          label: 'Status',
          dataType: 'translate',
          translations: [{
            key: 'Quoted',
            value: 'Offererad'
          }, {
            key: 'Planned',
            value: 'Planerad'
          }, {
            key: 'Started',
            value: 'Pågående'
          }, {
            key: 'Registered',
            value: 'Registrerad'
          }, {
            key: 'Invoiced',
            value: 'Fakturerad'
          }, {
            key: 'Cancelled',
            value: 'Makulerad'
          }]
          // actionType: 'fieldAction',
          // action: 'displayWorkOrder'
        },
        /*
        {
          fieldId: 'createdByUserInitials',
          label: 'Skapad av'
          // actionType: 'fieldAction',
          // action: 'displayCreatorUser'
        },
        */
        {
          fieldId: 'workOrderOwnerDisplayText',
          label: 'Ägare'
          // actionType: 'fieldAction',
          // action: 'displayOwnerUser'
        },
        {
          fieldId: 'workOrderHelperDisplayText',
          label: 'Stöd'
          // actionType: 'fieldAction',
          // action: 'displayHelperUser'
        },
        {
          fieldId: 'internalNote',
          label: 'Intern not'
          // actionType: 'fieldAction',
          // action: 'displayWorkOrder'
        },
        {
          fieldId: 'hoursEstimated',
          label: 'Est. tid',
          dataType: 'number',
          disableOrdering: true,
          suffix: 'h'
          // actionType: 'fieldAction',
          // action: 'displayWorkOrder'
        },
        {
          fieldId: 'invoiceableHours',
          label: 'Deb. tid',
          dataType: 'number',
          disableOrdering: true,
          suffix: 'h'
          // actionType: 'fieldAction',
          // action: 'displayWorkOrder'
        },
        {
          fieldId: 'hoursWorked',
          label: 'Arb. tid',
          dataType: 'number',
          disableOrdering: true,
          suffix: 'h'
          // actionType: 'fieldAction',
          // action: 'displayWorkOrder'
        },
        {
          fieldId: 'value',
          label: 'Värde',
          dataType: 'currency',
          disableOrdering: true
          // actionType: 'fieldAction',
          // action: 'displayWorkOrder'
        }]
      },

      actionMeta: {
        type: 'buttons',
        items: [{
          label: '',
          action: 'updateWorkOrder',
          iconClass: 'fal fa-pen'
        }]
      }
    }
  },

  watch: {
    'workOrders.filter': {
      handler () {
        this.tableMeta.controls.find(x => x.action === 'filterByStatuses').value = this.workOrders.filter.statuses
        this.workOrders.currentPage = 1
        this.getListData()
      },
      deep: true
    }
  },

  computed: {
    ...mapState({
      workOrders: state => state.workOrdersShare.all
    })
  },

  methods: {
    ...mapActions('workOrdersShare', ['initialize', 'getListData', 'delete']),
    ...mapGetters('workOrdersShare', ['getStatusOptions']),

    tableControlAction (control) {
      switch (control.action) {
        case 'filterByStatus':
          this.workOrders.filter.status = control.value
          break
      }
    },

    rowAction (action, workOrder) {
      switch (action) {
        case 'updateWorkOrder':
          this.openWorkOrderModal(workOrder.projectCode, workOrder.workOrderId)
          break
        default:
          this.$alert(action + ' is not defined!')
          break
      }
    },

    fieldAction (action, workOrder) {
      switch (action) {
        case 'displayCustomer':
          this.$panel(CustomerModal, { id: workOrder.customerId }).then(() => {
            this.getProjectsList() // Why?
          })
          break
        case 'displayProject':
          this.$panel(ProjectModal, { id: workOrder.projectId })
          break
        case 'displayCreatorUser':
          if (!workOrder.createdByUserId) {
            return
          }
          this.$panel(UserModal, { id: workOrder.workOrderOwnerUserId }).then(() => {
            this.getProjectsList() // Why?
          })
          break
        case 'displayOwnerUser':
          if (!workOrder.workOrderOwnerUserId) {
            return
          }
          this.$panel(UserModal, { id: workOrder.workOrderOwnerUserId }).then(() => {
            this.getProjectsList() // Why?
          })
          break
        case 'displayHelperUser':
          if (!workOrder.workOrderHelperUserId) {
            return
          }
          this.$panel(UserModal, { id: workOrder.workOrderHelperUserId }).then(() => {
            this.getProjectsList() // Why?
          })
          break
        case 'displayWorkOrder':
          this.$panel(WorkOrderModal, { projectCode: workOrder.projectCode, workOrderId: workOrder.workOrderId }, 1000)
          break
        default:
          this.$alert(action + ' is not defined!')
          break
      }
    },

    openWorkOrderModal (projectCode, workOrderId) {
      this.$panel(WorkOrderModal, { projectCode, workOrderId }, 1000)
    }
  },
  created () {
    this.initialize()

    this.filterMeta.find(x => x.fieldId === 'statuses').options = this.getStatusOptions()
    this.tableMeta.controls.find(x => x.fieldId === 'statuses').options = this.getStatusOptions()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Admin/Home/SharePage.vue